import { groupBy } from "./../utils";
import axios from "axios";
import moment from "moment";

import { API, JAVA_MASTER_API } from "../../constants";

/* FILTERS */
// fetches all districts
export const getDistricts = () => {
  return axios.get(JAVA_MASTER_API + "districts");
};

// fetches all blocks based on selected district
export const getBlocks = (districtId: number) => {
  return axios.get(
    JAVA_MASTER_API + `blocks?districtID=${districtId}`
  );
};

// fetch all schools based on selected district and selected block
export const getSchools = (blockId: number) => {
  return axios.get(JAVA_MASTER_API + `schools?blockID=${blockId}`);
};

// fetche all grades (For now, fetches only grade 9 and grade 10)
export const getGrades = () => {
  return axios.get(JAVA_MASTER_API + `grades`);
};

/* REPORTS */
// fetches all student performance based on selected district, block and school
export const getMonthlyStudentPerformance = (
  ITEM_LIMIT: number,
  offset: number,
  session: number,
  district_id?: number,
  block_id?: number,
  school_id?: number,
  grade_id?: number,
  start_date?: string,
  end_date?: string
) => {
  return axios.get(
    API +
      `custom/stats_admin/student/performance?grade_id=${
        grade_id || -1
      }&student_id=-1&grade_section_id=-1&district=${district_id || -1}&block=${
        block_id || -1
      }&school=${school_id || -1}&start_date=${start_date || -1}&end_date=${
        end_date || -1
      }&limit=${ITEM_LIMIT}&offset=${offset}&session=${session}`
  );
};

// fetches all student content progress based on selected district, block and school
export const getMonthlyStudentProgress = (
  ITEM_LIMIT: number,
  offset: number,
  session: number,
  district_id?: number,
  block_id?: number,
  school_id?: number,
  grade_id?: number,
  start_date?: string | number,
  end_date?: string | number
) => {
  return axios.get(
    API +
      `custom/stats_admin/student/contentUsage?grade_id=${
        grade_id || -1
      }&student_id=-1&grade_section_id=-1&district=${district_id || -1}&block=${
        block_id || -1
      }&school=${school_id || -1}&start_date=${start_date || -1}&end_date=${
        end_date || -1
      }&limit=${ITEM_LIMIT}&offset=${offset}&session=${session}`
  );
};

// fetches all student's overall avg. app usage based on selected district, block and school
export const getStudentAvgAppUsage = (
  ITEM_LIMIT: number,
  offset: number,
  session: number,
  district_id?: number,
  block_id?: number,
  school_id?: number,
  grade_id?: number,
  start_date?: string,
  end_date?: string
) => {
  return axios.get(
    API +
      `custom/stats_admin/student/appUsage?grade_id=${
        grade_id || -1
      }&student_id=-1&grade_section_id=-1&district=${district_id || -1}&block=${
        block_id || -1
      }&school=${school_id || -1}&start_date=${start_date || -1}&end_date=${
        end_date || -1
      }&limit=${ITEM_LIMIT}&offset=${offset}&session=${session}`
  );
};

// fetches all student performance based on selected district, block and school
export const getStudentPerformance = (
  ITEM_LIMIT: number,
  offset: number,
  session: number,
  district_id?: number,
  block_id?: number,
  school_id?: number,
  grade_id?: number,
  start_date?: string,
  end_date?: string
) => {
  const numberOfDays =
    end_date && start_date ? moment(end_date).diff(start_date, "days") : 7;
  return axios.get(
    API +
      `custom/stats_admin/student/performance/improvement?grade_id=${
        grade_id || -1
      }&session=${session}&student_id=-1&grade_section_id=-1&district=${
        district_id || -1
      }&block=${block_id || -1}&school=${
        school_id || -1
      }&by_month_or_week=${numberOfDays}&limit=${ITEM_LIMIT}&offset=${
        offset || 0
      }`
  );
};

// fetches enrolled students based on selected district, block (by default - all district)
export const getEnrolledStudents = (
  session: number,
  district_id?: number,
  block_id?: number
) => {
  const groupBy = district_id ? (block_id ? "school" : "block") : "district";
  return axios.get(
    API +
      `custom/stats_admin/student/enrolled?grade_id=-1&grade_section_id=-1&district=${
        district_id || -1
      }&block=${
        block_id || -1
      }&school=-1&group_by=${groupBy}&session=${session}`
  );
};

// fetches enrolled teachers based on selected district, block (by default - all district)
export const getEnrolledTeachers = (
  group_by: string,
  session: number,
  district_id?: number,
  block_id?: number
) => {
  return axios.get(
    API +
      `custom/stats_admin/teacher/enrolled?grade_id=-1&grade_section_id=-1&district=${
        district_id || -1
      }&block=${
        block_id || -1
      }&school=-1&group_by=${group_by}&session=${session}`
  );
};

// get ticket data
export const generateTicketReport = (
  start_date: string | number,
  end_date: string | number
) => {
  return axios.get(
    API +
      `custom/ticket?start_date=${
        start_date || moment("2021-11-30").format("YYYY-MM-DD")
      }&end_date=${moment(end_date).add(1, "d").format("YYYY-MM-DD")}`
  );
};

/*
     NEW REPORTS 
*/
// get adaptive assessment count for students
export const getAdaptiveAssessmentCount = (
  session: number,
  school_id: number,
  start_date: string | number,
  end_date: string | number,
  limit: number,
  offset: number
) => {
  return axios.get(
    API +
      `custom/stats_admin/student/adaptive_count?school=${school_id}&start_date=${start_date}&end_date=${end_date}&limit=${limit}&offset=${offset}&session=${session}`
  );
};

export const getTeacherNudges = (school_id: number) => {
  return axios.get(
    API + `custom/stats_admin/teacher/nudges_count?school=${school_id}`
  );
};
export const getActiveStudentData = (date: {
  start_date: string;
  end_date: string;
}) => {
  return axios.get(
    API +
      `custom/stats_admin/active/students?start_date=${date?.start_date}&end_date=${date?.end_date}`
  );
};
